import { createAction } from '@reduxjs/toolkit';

export const useMerchandisingRulesWSActions = {
  delete: createAction<{ ruleId: string }>('UseMerchandisingRulesWS/Delete'),
  notification: createAction<{ customMessage: string }>('UseMerchandisingRulesWS/Notification'),
};
